import React from 'react';
import {Link} from 'react-router-dom';
import {history} from '../routers/AppRouter';

export default class WorkListItem extends React.Component{

    

    render(){
        return(
            <div className="col-md-3 col-sm-4 col-xs-6 cover" style={{backgroundImage: `url(${this.props.imageurl})`}}>
                { this.props.id ? <Link className="button goToWork" to={{pathname:`/work/${this.props.id}`, state: { prevPath: location.pathname }}}></Link> : undefined}
                <div className="shadow"></div>
                
                <div className="workInfo v-center">
                <div className="row">
                    <div className="col-xs-12">
                        {/*<h3>{title}</h3>*/}
                            {
                                this.props.fields[0]  ? <p>Web development</p> : undefined
                            }
                            {
                                this.props.fields[1]  ? <p>Web design</p> : undefined
                            }
                            {
                                this.props.fields[2]  ? <p>Mob application</p> : undefined
                            }
                        <div className="fildesIconSet">
                            {
                                this.props.fields[0]  ? <img src="/images/webapp_icon.png" /> : undefined
                            }
                            {
                                this.props.fields[1]  ? <img src="/images/design_icon.png" /> : undefined
                            }
                            {
                                this.props.fields[2]  ? <img src="/images/mobapp_icon.png" /> : undefined
                            }
                        </div>
                    </div>
                    {/*
                    <div className="col-xs-4">
                        {
                            logourl ? <img className="img-responsive" src={logourl} /> : undefined
                        }
                        
                    </div>
                    */}
                    
                </div>
                
                </div>
                
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/WorkListItem.js